<template>
  <div>
    <h4>Productos sin movimiento</h4>
    <p>Revisa los siguientes productos listados que en las últimas 4 semanas han tenido poca venta, pero tienen una elevada carga de stock.
    El listado esta ordenado de tal manera que los mas afectados se listan primero.</p>
    <Loader v-if="loading"></Loader>
    <b-list-group v-else>
      <b-list-group-item list-group-item-action class="pointer" v-for="list in data" :key="list.product_map_id">
        <b-card class="border-0">
          Información producto proveedor
          <h6>{{list.vendor_product_description}}</h6>
          <h6>{{list.vendor_product_code}}</h6>
          Información producto cadena
          <h6>{{list.retail_product_description}}</h6>
          <h6>{{list.retail_product_code}}</h6>
        </b-card>
        <b-card class="text-center border-0">
          <b-row>
            <!--<b-col cols="6">-->
              <!--Venta en unidades-->
              <!--<h6>{{list.quantity_sold_1 | number}}</h6>-->
            <!--</b-col>-->
            <b-col>
              Unidades de Stock
              <h1>{{list.stock_quantity | number}}</h1>
            </b-col>
          </b-row>
          <!--<b-row class="mt-2">-->
            <!--<b-col cols="6">-->
              <!--Venta en $-->
              <!--<h6>{{list.real_sales_amount | money}}</h6>-->
            <!--</b-col>-->
            <!--<b-col cols="6">-->
              <!--Stock en $ (PVP)-->
              <!--<h6>{{list.real_stock_pvp_amount | money}}</h6>-->
            <!--</b-col>-->
          <!--</b-row>-->
        </b-card>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>


<script>
  import { WmProductParameters } from '../../expertoRetail/defaultPayloads/organismsMobile'
  import { sales } from '../../services/api/ExpertoRetail'
  import Loader from '@/expertoRetail/atoms/ExpertoRetailLoader'

  export default {
    name: 'wm-product-list',
    props: {
    },
    components: {
      Loader
    },
    data () {
      return {
        data: {},
        store_id: this.$store.state.mobile.store_id,
        loading: false
      }
    },
    created () {
      this.addFilter(this.store_id)
    },
    methods: {
      storeListRequest (parameters) {
        this.loading = true
        return new Promise((resolve, reject) => {
          let vm = this
          sales.salesTwoRanges(parameters)
            .then(response => {
              vm.data = response.data
              resolve()
            })
            .catch(error => {
              reject(error)
            })
            .finally(() => {
              vm.loading = false
            })
        })
      },
      addFilter (id) {
        WmProductParameters.parameters.store_filters.store_id = []
        WmProductParameters.parameters.store_filters.store_id.push(id.toString())
        this.storeListRequest(WmProductParameters)
      }
    }
  }
</script>


<style scoped>
  .bk-color {
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#1e5799+0,25146d+0,3f137c+73,50327a+98 */
    background: #0d1052; /* Old browsers */
  }
  .transparent {
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/expertoRetail/atoms/ExpertoRetailMobileWmProductList.vue